/* eslint-disable */
import React, { useState, useEffect } from "react";
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import { useSelector } from "react-redux";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import apicache from "../../components/clearCach/clear";
import { Switch, InputNumber } from "antd";
import {
  Settings,
  FormInput,
  UserRound,
  Phone,
  MapPin,
  MessageSquare,
  ShoppingCart,
  Save,
  Info,
} from "lucide-react";
import { useTranslation } from "react-i18next";

function Delevery() {
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const [showSideBar, setShowSideBar] = useState(true);
  const [data, setData] = useStoreFormDraft(store);
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  const [show, setShow] = useState(false);

  const [filter, setFilter] = useState("");
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const message = (e) => {
    e.preventDefault();
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: (
        <a href="https://m.me/F0orweb" target="_blank">
          {t("footerSettings.swal_contact_link")}
        </a>
      ),
      isDismissed: true,
      confirmButtonColor: "#9b59bf",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    apicache(account, products);

    try {
      await saveStoreDraft(doc(db, "store", data.id), store, data);
      Swal.fire({
        icon: "success",
        title: t("FormSettings.alerts.save_success.title"),
        confirmButtonText: t("FormSettings.alerts.save_success.confirm"),
        confirmButtonColor: "#9b59bf",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: t("FormSettings.alerts.save_error.title"),
        text: t("FormSettings.alerts.save_error.text"),
        confirmButtonText: t("FormSettings.alerts.save_error.confirm"),
        confirmButtonColor: "#9b59bf",
      });
    } finally {
      setLoading(false);
    }
  };

  // Form field toggle handlers
  const handleDChange = () => setData({ ...data, note: !data.note });
  const handleDChange1 = () => setData({ ...data, noteR: !data.noteR });
  const handleDChange2 = () => setData({ ...data, wilayaR: !data.wilayaR });
  const handleDChange3 = () => setData({ ...data, communeR: !data.communeR });
  const handleDChange4 = () => setData({ ...data, adressR: !data.adressR });
  const handleDChange7 = () => setData({ ...data, nameR: !data.nameR });
  const handleDChange5 = () => setData({ ...data, names: !data.names });
  const handleDChange6 = () => setData({ ...data, num: !data.num });
  const handleDChange8 = () => setData({ ...data, numR: !data.numR });
  const handleDChange9 = () =>
    setData({ ...data, communewrite: !data.communewrite });
  const handleDChange10 = () =>
    setData({
      ...data,
      wilayawrite: !data.wilayawrite,
      communewrite: !data.communewrite,
    });
  const handleDChange11 = () => {
    setData({ ...data, receiptIsActive: !data.receiptIsActive });
    setIsVisible(!data.receiptIsActive);
  };
  const handleDChange12 = () =>
    setData({ ...data, notShowPhoneNote: !data.notShowPhoneNote });
  const handleDChange13 = () =>
    setData({ ...data, notShowDelivery: !data.notShowDelivery });
  const handleDChange14 = () =>
    setData({ ...data, notShowCheckout: !data.notShowCheckout });
  const handleDChange15 = () =>
    setData({ ...data, freeDeliveryEnabled: !data.freeDeliveryEnabled });
  const handleDChange16 = () =>
    setData({ ...data, notShowPriceInButton: !data.notShowPriceInButton });
  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen"
      dir={isRTL ? 'rtl' : 'ltr'}

    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div className="px-3 dark:!bg-[#141414]" style={{ flex: 1, backgroundColor: "#fbf8fc" }}>
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("FormSettings.page_title")}
                </h2>
                <p className="text-gray-600 dark:!text-gray-300 mb-0">
                  {t("FormSettings.page_subtitle")}
                </p>
              </div>
              <button
                onClick={!!account.store ? handleSubmit : message}
                className={`flex items-center gap-2 bg-[#9b59bf] hover:bg-[#814a9f] text-white py-2 px-4 rounded-lg transition-colors ${loading ? "opacity-75 cursor-wait" : ""
                  }`}
                disabled={loading}
              >
                <Save size={18} />
                <span className="mr-1">
                  {loading ? t("FormSettings.saving") : t("FormSettings.save_button")}
                </span>
              </button>
            </div>
          </div>

          {/* Main Content */}
          <div className="mx-3 mb-6">
            {data && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Form Settings Column */}
                <div className="md:col-span-2">
                  {/* Form Header Section */}
                  <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-6">
                    <div className="flex items-center mb-4">
                      <FormInput size={20} className="text-[#9e68ba] ml-2" />
                      <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-300">
                        {t("FormSettings.form_message.title")}
                      </h3>
                    </div>

                    <div className="mb-4">
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("FormSettings.form_message.description_label")}
                      </label>
                      <input
                        value={data.headersform || ""}
                        onChange={(e) =>
                          setData({
                            ...data,
                            headersform: e.target.value,
                          })
                        }
                        type="text"
                        placeholder={t("FormSettings.form_message.description_placeholder")}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                      />
                    </div>

                    <div className="mb-4">
                      <label className="block text-sm font-medium text-[#9e68ba] mb-2">
                        {t("FormSettings.form_message.button_label")}
                      </label>
                      <input
                        value={data.nameboutton || ""}
                        onChange={(e) =>
                          setData({
                            ...data,
                            nameboutton: e.target.value,
                          })
                        }
                        type="text"
                        placeholder={t("FormSettings.form_message.button_placeholder")}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                      />
                    </div>
                  </div>

                  {/* Personal Info Fields */}
                  <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-6">
                    <div className="flex items-center mb-4">
                      <UserRound size={20} className="text-[#9e68ba] ml-2" />
                      <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-300">
                        {t("FormSettings.customer_info.title")}
                      </h3>
                    </div>

                    {/* Name Field */}
                    <div className="border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-4 mb-4">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-x-2">
                          <input
                            type="checkbox"
                            checked={data.names}
                            onChange={handleDChange5}
                            className="h-4 w-4 text-purple-600 rounded border-gray-300 focus:ring-purple-200"
                          />
                          <label className="ml-2 block text-sm font-medium text-gray-700 dark:!text-gray-300">
                            {t("FormSettings.customer_info.name.label")}
                          </label>
                        </div>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>{t("FormSettings.customer_info.name.tooltip")}</Tooltip>}
                        >
                          <span>
                            <Info size={16} className="text-gray-400 dark:!text-gray-500" />
                          </span>
                        </OverlayTrigger>
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder={t("FormSettings.customer_info.name.tooltip")}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                          value={data.namepreno || ""}
                          onChange={(e) =>
                            setData({
                              ...data,
                              namepreno: e.target.value,
                            })
                          }
                          disabled={!data.names}
                        />
                      </div>

                      <div className="flex items-center gap-2">
                        <Switch
                          size="small"
                          checked={data.nameR}
                          onChange={handleDChange7}
                          disabled={!data.names}
                          className="bg-gray-300 dark:!bg-[#3c3a3d]"
                        />
                        <span className="text-sm text-gray-600 dark:!text-gray-400">
                          {t("FormSettings.customer_info.name.required")}
                        </span>
                      </div>
                    </div>

                    {/* Phone Field */}
                    <div className="border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-4">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-x-2">
                          <input
                            type="checkbox"
                            checked={data.num}
                            onChange={(e) => {
                              if (data.num) return;
                              handleDChange6(e);
                            }}
                            className="h-4 w-4 text-purple-600 rounded border-gray-300 focus:ring-purple-200"
                            disabled={data.num}
                          />
                          <label className="ml-2 block text-sm font-medium text-gray-700 dark:!text-gray-300">
                            {t("FormSettings.customer_info.phone.label")}
                          </label>
                        </div>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>{t("FormSettings.customer_info.phone.tooltip")}</Tooltip>}
                        >
                          <span>
                            <Phone size={16} className="text-gray-400 dark:!text-gray-500" />
                          </span>
                        </OverlayTrigger>
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder={t("FormSettings.customer_info.phone.placeholder")}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                          value={data.numphone || ""}
                          onChange={(e) =>
                            setData({
                              ...data,
                              numphone: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="flex items-center gap-2 mb-3">
                        <Switch
                          size="small"
                          checked={data.numR}
                          onChange={handleDChange8}
                          className="bg-gray-300 dark:!bg-[#3c3a3d]"
                          disabled={true}
                        />
                        <span className="text-sm text-gray-600 dark:!text-gray-400">
                          {t("FormSettings.customer_info.phone.required")}
                        </span>
                      </div>

                      <div className="flex flex-wrap items-center gap-2">
                        <span className="text-sm text-gray-600 dark:!text-gray-400">
                          {t("FormSettings.customer_info.phone.min_digits")}
                        </span>
                        <InputNumber
                          size="small"
                          dir="ltr"
                          style={{ width: "60px" }}
                          value={data.numberPhone}
                          onChange={(value) =>
                            setData({
                              ...data,
                              numberPhone: value,
                            })
                          }
                          min={0}
                          max={20}
                        />
                        <span className="text-sm text-gray-600 ml-2 dark:!text-gray-400">
                          {t("FormSettings.customer_info.phone.max_digits")}
                        </span>
                        <InputNumber
                          size="small"
                          dir="ltr"
                          style={{ width: "60px" }}
                          value={data.numberPhonemax}
                          onChange={(value) =>
                            setData({
                              ...data,
                              numberPhonemax: value,
                            })
                          }
                          min={0}
                          max={20}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Address Fields */}
                  <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-6">
                    <div className="flex items-center mb-4">
                      <MapPin size={20} className="text-[#9e68ba] ml-2" />
                      <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-300">
                        {t("FormSettings.address_info.title")}
                      </h3>
                    </div>

                    {/* State Field */}
                    <div className="border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-4 mb-4">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-x-2">
                          <input
                            type="checkbox"
                            checked={data.delevery?.wilaya}
                            onChange={() =>
                              setData({
                                ...data,
                                delevery: {
                                  ...data.delevery,
                                  wilaya: !data.delevery?.wilaya,
                                },
                              })
                            }
                            className="h-4 w-4 text-purple-600 rounded border-gray-300 focus:ring-purple-200"
                          />
                          <label className="ml-2 block text-sm font-medium text-gray-700 dark:!text-gray-300">
                            {t("FormSettings.address_info.state.label")}
                          </label>
                        </div>
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder={t("FormSettings.address_info.state.placeholder")}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                          value={data.wilayaName || ""}
                          onChange={(e) =>
                            setData({
                              ...data,
                              wilayaName: e.target.value,
                            })
                          }
                          disabled={!data.delevery?.wilaya}
                        />
                      </div>

                      <div className="flex items-center gap-2 mb-3">
                        <Switch
                          size="small"
                          checked={data.wilayaR}
                          onChange={handleDChange2}
                          className="bg-gray-300 dark:!bg-[#3c3a3d]"
                          disabled={!data.delevery?.wilaya}
                        />
                        <span className="text-sm text-gray-600 dark:!text-gray-400">
                          {t("FormSettings.address_info.state.required")}
                        </span>
                      </div>

                      <div className="flex items-center gap-2">
                        <Switch
                          size="small"
                          checked={data.wilayawrite}
                          onChange={handleDChange10}
                          className="bg-gray-300 dark:!bg-[#3c3a3d]"
                          disabled={!data.delevery?.wilaya}
                        />
                        <span className="text-sm text-gray-600 dark:!text-gray-400">
                          {t("FormSettings.address_info.state.allow_manual")}
                        </span>
                      </div>
                    </div>

                    {/* City Field */}
                    <div className="border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-4 mb-4">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-x-2">
                          <input
                            type="checkbox"
                            checked={data.delevery?.activeCities}
                            onChange={() =>
                              setData({
                                ...data,
                                delevery: {
                                  ...data.delevery,
                                  activeCities: !data.delevery?.activeCities,
                                },
                              })
                            }
                            className="h-4 w-4 text-purple-600 rounded border-gray-300 focus:ring-purple-200"
                          />
                          <label className="ml-2 block text-sm font-medium text-gray-700 dark:!text-gray-300">
                            {t("FormSettings.address_info.city.label")}
                          </label>
                        </div>
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder={t("FormSettings.address_info.city.placeholder")}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                          value={data.communeName || ""}
                          onChange={(e) =>
                            setData({
                              ...data,
                              communeName: e.target.value,
                            })
                          }
                          disabled={!data.delevery?.activeCities}
                        />
                      </div>

                      <div className="flex items-center gap-2 mb-3">
                        <Switch
                          size="small"
                          checked={data.communeR}
                          onChange={handleDChange3}
                          className="bg-gray-300 dark:!bg-[#3c3a3d]"
                          disabled={!data.delevery?.activeCities}
                        />
                        <span className="text-sm text-gray-600 dark:!text-gray-400">
                          {t("FormSettings.address_info.city.required")}
                        </span>
                      </div>

                      <div className="flex items-center gap-2">
                        <Switch
                          size="small"
                          checked={data.communewrite}
                          onChange={handleDChange9}
                          className="bg-gray-300 dark:!bg-[#3c3a3d]"
                          disabled={!data.delevery?.activeCities}
                        />
                        <span className="text-sm text-gray-600 dark:!text-gray-400">
                          {t("FormSettings.address_info.city.allow_manual")}
                        </span>
                      </div>
                    </div>

                    {/* Address Field */}
                    <div className="border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-4">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-x-2">
                          <input
                            type="checkbox"
                            checked={data.delevery?.address}
                            onChange={() =>
                              setData({
                                ...data,
                                delevery: {
                                  ...data.delevery,
                                  address: !data.delevery?.address,
                                },
                              })
                            }
                            className="h-4 w-4 text-purple-600 rounded border-gray-300 focus:ring-purple-200"
                          />
                          <label className="ml-2 block text-sm font-medium text-gray-700 dark:!text-gray-300">
                            {t("FormSettings.address_info.address.label")}
                          </label>
                        </div>
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder={t("FormSettings.address_info.address.placeholder")}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                          value={data.AdressName || ""}
                          onChange={(e) =>
                            setData({
                              ...data,
                              AdressName: e.target.value,
                            })
                          }
                          disabled={!data.delevery?.address}
                        />
                      </div>

                      <div className="flex items-center gap-2">
                        <Switch
                          size="small"
                          checked={data.adressR}
                          onChange={handleDChange4}
                          className="bg-gray-300 dark:!bg-[#3c3a3d]"
                          disabled={!data.delevery?.address}
                        />
                        <span className="text-sm text-gray-600 dark:!text-gray-400">
                          {t("FormSettings.address_info.address.required")}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Note Field */}
                  <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-6">
                    <div className="flex items-center mb-4">
                      <MessageSquare size={20} className="text-[#9e68ba] ml-2" />
                      <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-300">
                        {t("FormSettings.note_field.title")}
                      </h3>
                    </div>

                    <div className="border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-4">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-x-2">
                          <input
                            type="checkbox"
                            checked={data.note}
                            onChange={handleDChange}
                            className="h-4 w-4 text-purple-600 rounded border-gray-300 focus:ring-purple-200"
                          />
                          <label className="ml-2 block text-sm font-medium text-gray-700 dark:!text-gray-300">
                            {t("FormSettings.note_field.enabled_label")}
                          </label>
                        </div>
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder={t("FormSettings.note_field.placeholder")}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                          value={data.noteplaceholder || ""}
                          onChange={(e) =>
                            setData({
                              ...data,
                              noteplaceholder: e.target.value,
                            })
                          }
                          disabled={!data.note}
                        />
                      </div>

                      <div className="flex items-center gap-2">
                        <Switch
                          size="small"
                          checked={data.noteR}
                          onChange={handleDChange1}
                          className="bg-gray-300 dark:!bg-[#3c3a3d]"
                          disabled={!data.note}
                        />
                        <span className="text-sm text-gray-600 dark:!text-gray-400">
                          {t("FormSettings.note_field.required")}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Additional Settings */}
                  <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                    <div className="flex items-center mb-4">
                      <Settings size={20} className="text-[#9e68ba] ml-2" />
                      <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-300">
                        {t("FormSettings.other_settings.title")}
                      </h3>
                    </div>

                    <div className="space-y-4">
                      {/* Keep Receipt Open */}
                      <div className="flex items-center justify-between py-2 border-b border-gray-100 dark:!border-[#3c3a3d]">
                        <span className="text-gray-700 dark:!text-gray-300">
                          {t("FormSettings.other_settings.keep_receipt_open")}
                        </span>
                        <Switch
                          checked={data.receiptIsActive}
                          onChange={handleDChange11}
                          className="bg-gray-300 dark:!bg-[#3c3a3d]"
                        />
                      </div>

                      {/* Hide Phone Note */}
                      <div className="flex items-center justify-between py-2 border-b border-gray-100 dark:!border-[#3c3a3d]">
                        <span className="text-gray-700 dark:!text-gray-300">
                          {t("FormSettings.other_settings.hide_phone_note")}
                        </span>
                        <Switch
                          checked={data.notShowPhoneNote}
                          onChange={handleDChange12}
                          className="bg-gray-300 dark:!bg-[#3c3a3d]"
                        />
                      </div>

                      {/* Hide Delivery Pricing */}
                      <div className="flex items-center justify-between py-2 border-b border-gray-100 dark:!border-[#3c3a3d]">
                        <span className="text-gray-700 dark:!text-gray-300">
                          {t("FormSettings.other_settings.hide_delivery_pricing")}
                        </span>
                        <Switch
                          checked={data.notShowDelivery}
                          onChange={handleDChange13}
                          className="bg-gray-300 dark:!bg-[#3c3a3d]"
                        />
                      </div>

                      {/* Show Free Delivery */}
                      <div className="flex items-center justify-between py-2 border-b border-gray-100 dark:!border-[#3c3a3d]">
                        <span className="text-gray-700 dark:!text-gray-300">
                          {t("FormSettings.other_settings.show_free_delivery")}
                        </span>
                        <Switch
                          checked={!!data.freeDeliveryEnabled}
                          onChange={handleDChange15}
                          className="bg-gray-300 dark:!bg-[#3c3a3d]"
                        />
                      </div>

                      {/* Hide Checkout Summary */}
                      <div className="flex items-center justify-between py-2 border-b border-gray-100 dark:!border-[#3c3a3d]">
                        <span className="text-gray-700 dark:!text-gray-300">
                          {t("FormSettings.other_settings.hide_checkout_summary")}
                        </span>
                        <Switch
                          checked={data.notShowCheckout}
                          onChange={handleDChange14}
                          className="bg-gray-300 dark:!bg-[#3c3a3d]"
                        />
                      </div>

                      {/* Hide Price in Buy Button */}
                      <div className="flex items-center justify-between py-2">
                        <span className="text-gray-700 dark:!text-gray-300">
                          {t("FormSettings.other_settings.hide_price_in_buy_button")}
                        </span>
                        <Switch
                          checked={!!data.notShowPriceInButton}
                          onChange={handleDChange16}
                          className="bg-gray-300 dark:!bg-[#3c3a3d]"
                        />
                      </div>
                    </div>
                  </div>

                </div>

                {/* Preview Column */}
                <div className="md:col-span-1">
                  <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d] sticky top-6">
                    <div className="flex items-center mb-4">
                      <ShoppingCart size={20} className="text-[#9e68ba] ml-2" />
                      <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-300">
                        {t("FormSettings.preview.title")}
                      </h3>
                    </div>

                    <div
                      className="max-w-md mx-auto rounded-xl border p-4 mb-4 dark:!bg-[#141414] dark:!border-[#3c3a3d]"
                      style={{
                        border: `1px solid ${data.color1 || "#9b59bf"}`,
                      }}
                    >
                      <p className="text-gray-700 dark:!text-gray-300 mb-4">
                        {data.headersform || t("FormSettings.preview.default_message")}
                      </p>

                      <form className="space-y-4">
                        {!data.notShowPhoneNote && (
                          <p className="text-red-500 text-xs py-2 px-3 bg-red-50 dark:!bg-[#3c3a3d] rounded-md text-center">
                            {t("FormSettings.preview.missing_numbers", { count: data.NumberPhone || 10 })}
                          </p>
                        )}

                        {/* Inputs */}
                        <div className="grid grid-cols-2 gap-3">
                          {data?.names && (
                            <div>
                              <input
                                type="text"
                                readOnly
                                value=""
                                placeholder={data.namepreno || t("FormSettings.preview.default_name")}
                                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                              />
                              {data.nameR && (
                                <div className="text-xs text-red-500 mt-1">
                                  {t("FormSettings.preview.required")}
                                </div>
                              )}
                            </div>
                          )}

                          <div>
                            <input
                              type="text"
                              readOnly
                              value=""
                              placeholder={data.numphone || t("FormSettings.preview.default_phone")}
                              className={`w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300 ${!data.notShowPhoneNote ? "border-red-300" : ""
                                }`}
                            />
                            {data.numR && (
                              <div className="text-xs text-red-500 mt-1">
                                {t("FormSettings.preview.required")}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Wilaya / Commune */}
                        <div className="grid grid-cols-2 gap-3">
                          {data?.delevery?.wilaya && (
                            <div>
                              {data.wilayawrite ? (
                                <input
                                  type="text"
                                  readOnly
                                  value=""
                                  placeholder={data.wilayaName || t("FormSettings.preview.default_wilaya")}
                                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                                />
                              ) : (
                                <select className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 bg-white dark:!bg-[#181819] dark:!text-gray-300 dark:!border-[#3c3a3d]">
                                  <option>{data.wilayaName || t("FormSettings.preview.default_wilaya")}</option>
                                </select>
                              )}
                              {data.wilayaR && (
                                <div className="text-xs text-red-500 mt-1">
                                  {t("FormSettings.preview.required")}
                                </div>
                              )}
                            </div>
                          )}

                          {data?.delevery?.activeCities && (
                            <div>
                              {data.communewrite ? (
                                <input
                                  type="text"
                                  readOnly
                                  value=""
                                  placeholder={data.communeName || t("FormSettings.preview.default_commune")}
                                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                                />
                              ) : (
                                <select className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 bg-white dark:!bg-[#181819] dark:!text-gray-300 dark:!border-[#3c3a3d]">
                                  <option>{data.communeName || t("FormSettings.preview.default_commune")}</option>
                                </select>
                              )}
                              {data.communeR && (
                                <div className="text-xs text-red-500 mt-1">
                                  {t("FormSettings.preview.required")}
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        {/* Delivery Price */}
                        {!data.notShowDelivery && (
                          <div className="w-full flex justify-between items-center" dir="ltr">
                            <div
                              className="flex gap-1 justify-center items-center text-white px-2 py-1 rounded-md text-xs"
                              style={{ background: data.color2 || "#9b59bf" }}
                            >
                              <span>{t("FormSettings.preview.select_state")}</span>
                            </div>
                            <div className="text-xs font-medium text-gray-700 dark:!text-gray-300">
                              {data.freeDeliveryEnabled
                                ? t("FormSettings.preview.free_delivery")
                                : t("FormSettings.preview.delivery_price")}
                            </div>
                          </div>
                        )}

                        {/* Address */}
                        {data.delevery?.address && (
                          <div>
                            <input
                              type="text"
                              readOnly
                              value=""
                              placeholder={data.AdressName || t("orders.address")}
                              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                            />
                            {data.adressR && (
                              <div className="text-xs text-red-500 mt-1">
                                {t("FormSettings.preview.required")}
                              </div>
                            )}
                          </div>
                        )}

                        {/* Note */}
                        {data?.note && (
                          <div>
                            <input
                              type="text"
                              readOnly
                              value=""
                              placeholder={data.noteplaceholder || t("orders.note")}
                              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                            />
                            {data.noteR && (
                              <div className="text-xs text-red-500 mt-1">
                                {t("FormSettings.preview.required")}
                              </div>
                            )}
                          </div>
                        )}

                        {/* Buy Button */}
                        <button
                          type="button"
                          className="w-full py-3 text-white rounded-lg font-medium transition-colors"
                          style={{ background: data.color2 || "#9b59bf" }}
                        >
                          {data?.nameboutton || t("FormSettings.preview.buy_now")}
                        </button>
                      </form>

                      {/* Checkout Summary */}
                      {!data.notShowCheckout && (
                        <div className="mt-4">
                          <button
                            onClick={() => setIsVisible(!isVisible)}
                            className="w-full flex justify-center items-center gap-2 py-2 px-3 bg-gray-50 dark:!bg-[#181819] border border-gray-200 dark:!border-[#3c3a3d] rounded-lg text-gray-700 dark:!text-gray-300 font-medium"
                          >
                            <span>{t("FormSettings.preview.checkout_summary")}</span>
                            <ShoppingCart size={18} />
                          </button>

                          {(isVisible || data.receiptIsActive) && (
                            <div className="mt-2 p-3 border border-gray-200 dark:!border-[#3c3a3d] rounded-lg dark:!bg-[#141414]" dir="ltr">
                              <div className="flex justify-between items-center mb-2">
                                <div className="flex items-center gap-2">
                                  <div className="text-sm font-medium dark:!text-gray-300">
                                    <span>2900</span>
                                    <span className="ml-1 text-gray-600 dark:!text-gray-400">{store?.currencySymbol}</span>
                                  </div>
                                  <div
                                    className="px-1 py-0.5 text-xs text-white rounded-md"
                                    style={{ background: data.color2 || "#9b59bf" }}
                                  >
                                    x1
                                  </div>
                                </div>
                                <div className="flex items-center gap-2">
                                  <div className="text-sm font-medium dark:!text-gray-300">
                                    {t("FormSettings.preview.product_name")}
                                  </div>
                                  <div className="h-10 w-10 bg-gray-200 dark:!bg-[#3c3a3d] rounded-full overflow-hidden">
                                    <img
                                      src="/product-foorweb.png"
                                      alt={t("ship.product")}
                                      className="h-full w-full object-cover"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                          "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23ccc' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='3' width='18' height='18' rx='2' ry='2'/%3E%3Ccircle cx='8.5' cy='8.5' r='1.5'/%3E%3Cpolyline points='21 15 16 10 5 21'/%3E%3C/svg%3E";
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>

                              {!data.notShowDelivery && (
                                <>
                                  <hr className="my-2 dark:!border-[#3c3a3d]" />
                                  <div className="flex justify-between items-center py-1">
                                    <div
                                      className="px-1 py-0.5 text-xs text-white rounded-md"
                                      style={{ background: data.color2 || "#9b59bf" }}
                                    >
                                      {t("FormSettings.preview.select_state")}
                                    </div>
                                    <div className="text-xs font-medium dark:!text-gray-300">
                                      {data.freeDeliveryEnabled
                                        ? t("FormSettings.preview.free_delivery")
                                        : t("FormSettings.preview.delivery_price")}
                                    </div>
                                  </div>
                                </>
                              )}

                              <hr className="my-2 dark:!border-[#3c3a3d]" />
                              <div className="flex justify-between items-center">
                                <div
                                  className="text-lg font-bold"
                                  style={{ color: data.color2 || "#9b59bf" }}
                                >
                                  <span>2900</span>
                                  <span className="ml-1">{store?.currencySymbol}</span>
                                </div>
                                <div className="text-base font-bold dark:!text-gray-300">
                                  {t("FormSettings.preview.total")}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

              </div>
            )}
          </div>

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Delevery;
